// Utils
import {
    getBackgroundColor,
    getColor,
    getElementType,
    getSecondaryColor,
} from '../../../../../common/elements/utils/elementPropertyUtils';
import { displayCommentAsCollapsed } from '../../../../../common/comments/commentModelUtil';
import { isIconViewLike } from '../../../../../common/elements/utils/elementDisplayUtils';

// Constants
import { COLORS, BACKGROUND_COLORS } from '../../../../../common/colors/colorConstants';
import { COMMENT_THREAD_TYPE } from '../../../../../common/comments/commentConstants';
import { getIsFeatureEnabled } from '../../../../element/feature/elementFeatureUtils';
import { ELEMENT_FEATURES } from '../../../../element/feature/elementFeatureConstants';
import { BOARD_TYPE } from '../../../../../common/boards/boardConstants';
import { LINE_TYPE } from '../../../../../common/lines/lineConstants';
import { ALIAS_TYPE } from '../../../../../common/alias/aliasConstants';
import { ANNOTATION_TYPE } from '../../../../../common/drawings/annotations/annotationConstants';
import { COLOR_SWATCH_TYPE } from '../../../../../common/colorSwatches/colorSwatchesConstants';
import { FILE_TYPE } from '../../../../../common/files/fileConstants';
import { DOCUMENT_TYPE } from '../../../../../common/documents/documentConstants';
import { TABLE_TYPE } from '../../../../../common/table/tableConstants';

const elementHasNoColor = (element) => !getColor(element);
const elementHasColor = (color) => (element) => color === getColor(element);

export const getIsColorActive = (selectedElements, color) => {
    const comparisonFn = !color || color === COLORS.NONE ? elementHasNoColor : elementHasColor(color.name || color);

    return selectedElements.every(comparisonFn);
};

export const getFirstSelectedColor = (selectedElements) => {
    if (!selectedElements || !selectedElements.first()) return;

    return getColor(selectedElements.first());
};

export const getFirstSelectedSecondaryColor = (selectedElements) => {
    if (!selectedElements || !selectedElements.first()) return;

    return getSecondaryColor(selectedElements.first());
};

const isTransparencyEnabled = getIsFeatureEnabled(ELEMENT_FEATURES.TRANSPARENT);

export const getFirstSelectedBackgroundColor = (selectedElements) => {
    if (!selectedElements || !selectedElements.first()) return;

    const color = getBackgroundColor(selectedElements.first());
    const transparent = isTransparencyEnabled(selectedElements.first());

    return transparent ? BACKGROUND_COLORS.TRANSPARENT.name : color;
};

export const getSelectedElementType = (selectedElements) =>
    selectedElements?.first() && getElementType(selectedElements.first());

export const getSelectedElementColorStatusClass = (selectedElements) => {
    const firstElement = selectedElements?.first();
    const elementType = getElementType(firstElement);

    switch (elementType) {
        case COMMENT_THREAD_TYPE: {
            const isCollapsed = displayCommentAsCollapsed(firstElement);
            return isCollapsed ? 'collapsed' : null;
        }
        default:
            return null;
    }
};

export const getSupportColorBar = (selectedElements) => {
    const firstElement = selectedElements.first();
    const elementType = getElementType(firstElement);

    switch (elementType) {
        case ANNOTATION_TYPE:
        case BOARD_TYPE:
        case ALIAS_TYPE:
        case LINE_TYPE:
        case COLOR_SWATCH_TYPE:
        case TABLE_TYPE:
            return false;
        case COMMENT_THREAD_TYPE:
            return !displayCommentAsCollapsed(firstElement);
        case FILE_TYPE:
        case DOCUMENT_TYPE:
            return !isIconViewLike(firstElement);
        default:
            return true;
    }
};
